const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname.endsWith('.localhost') ||
  window.location.hostname === '127.0.0.1'
);

const rawApiBase = process.env.REACT_APP_API_BASE || 
  (typeof window !== 'undefined' && !isLocalhost 
    ? `${window.location.protocol}//${window.location.host}` 
    : 'http://localhost:5000');

let apiBase = rawApiBase.endsWith('/api') 
  ? rawApiBase.slice(0, -4) 
  : rawApiBase.endsWith('/api/') 
    ? rawApiBase.slice(0, -5) 
    : rawApiBase;

// Auto-upgrade to HTTPS if accessed over HTTPS to prevent browser Mixed Content blocking
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && apiBase.startsWith('http://')) {
  apiBase = apiBase.replace('http://', 'https://');
}

export const SIGNALING_SERVER = apiBase;
export const API_BASE = apiBase;

const SCREENSHOT_MIN_INTERVAL_MS = 1000;
const DEFAULT_PERSONAL_SCREENSHOT_INTERVAL_MS = Number(process.env.REACT_APP_PERSONAL_SCREENSHOT_INTERVAL_MS || 300000);
const DEFAULT_AI_SCREENSHOT_INTERVAL_MS = Number(process.env.REACT_APP_AI_SCREENSHOT_INTERVAL_MS || 180000);

export const SCREENSHOT_INTERVAL_STORAGE_KEYS = {
  personal: 'screenshot_interval_personal_ms',
  ai: 'screenshot_interval_ai_ms',
};

const sanitizeIntervalMs = (value, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < SCREENSHOT_MIN_INTERVAL_MS) {
    return fallback;
  }
  return Math.floor(parsed);
};

const readIntervalFromStorage = (key, fallback) => {
  if (typeof window === 'undefined') return fallback;
  try {
    return sanitizeIntervalMs(window.localStorage.getItem(key), fallback);
  } catch {
    return fallback;
  }
};

export const getPersonalInterviewScreenshotIntervalMs = () => (
  readIntervalFromStorage(SCREENSHOT_INTERVAL_STORAGE_KEYS.personal, DEFAULT_PERSONAL_SCREENSHOT_INTERVAL_MS)
);

export const getAiInterviewScreenshotIntervalMs = () => (
  readIntervalFromStorage(SCREENSHOT_INTERVAL_STORAGE_KEYS.ai, DEFAULT_AI_SCREENSHOT_INTERVAL_MS)
);

export const iceServers = {
  iceServers: [
      {
        urls: "stun:stun.relay.metered.ca:80",
      },
      {
        urls: "turn:global.relay.metered.ca:80",
        username: "969da62c309155975945318e",
        credential: "jROI5jRo1tnzYJHM",
      },
      {
        urls: "turn:global.relay.metered.ca:80?transport=tcp",
        username: "969da62c309155975945318e",
        credential: "jROI5jRo1tnzYJHM",
      },
      {
        urls: "turn:global.relay.metered.ca:443",
        username: "969da62c309155975945318e",
        credential: "jROI5jRo1tnzYJHM",
      },
      {
        urls: "turns:global.relay.metered.ca:443?transport=tcp",
        username: "969da62c309155975945318e",
        credential: "jROI5jRo1tnzYJHM",
      },
  ]
};
